

import { Confirm } from 'framework-ui-components';
import StatoDichiarazione from 'enums/StatoDichiarazione';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';

import {
  cambioStatoMassivoAnnulla, cambioStatoMassivoDaInviare, cambioStatoMassivoCompleta,
  cambioStatoMassivoInLavorazione, stampaMassivaDiProva,
  stampaMassivaUfficiale, stampaMassivaVarie,
    creaTabulatoDebitiCrediti, creaTabulatoOneriAnnoPrecedente,
    creaTabulatoDettaglioProspettoLiquidazioneQuadroA, creaTabulatoDettaglioProspettoLiquidazioneQuadroB,
} from 'apis/setteTrentaApi';

const azioneMassivaStampaDiProva = (selezionati) => {
  const dichiarazioniIds = [];
  selezionati.forEach((element) => {
    if (element.IdDichiarazione != null) {
      dichiarazioniIds.push(element.IdDichiarazione);
    }
  });
  stampaMassivaDiProva(dichiarazioniIds).then((x) => {
    if (!x.Success) {
      x.DetectedProblems.unshift('Errore durante elaborazione stampe massiva di prova');
      SnackbarManager.notifyError(x.DetectedProblems);
    }
  });
};

const azioneMassivaStampaUfficiale = (selezionati) => {
  const dichiarazioniIds = [];
  selezionati.forEach((element) => {
    if (element.IdDichiarazione != null) {
      dichiarazioniIds.push(element.IdDichiarazione);
    }
  });
  stampaMassivaUfficiale(dichiarazioniIds).then((x) => {
    if (!x.Success) {
      x.DetectedProblems.unshift('Errore durante elaborazione stampa massiva ufficiale');
      SnackbarManager.notifyError(x.DetectedProblems);
    }
  });
};

const azioneMassivaStampeVarie = (selezionati) => {
  const dichiarazioniIds = [];
  selezionati.forEach((element) => {
    if (element.IdDichiarazione != null) {
      dichiarazioniIds.push(element.IdDichiarazione);
    }
  });
  stampaMassivaVarie(dichiarazioniIds).then((x) => {
    if (!x.Success) {
      x.DetectedProblems.unshift('Errore durante elaborazione stampe varie');
      SnackbarManager.notifyError(x.DetectedProblems);
    }
  });
};

const azioneMassivaDaInviare = (selezionati, anno) => {
  Confirm('Cambio stato', 'Trasmettere le dichiarazioni selezionate?', 'warning').then((y) => {
    const dichiarazioniIds = [];
    selezionati.forEach((element) => {
      if (element.IdDichiarazione != null) {
        dichiarazioniIds.push(element.IdDichiarazione);
      }
    });
    cambioStatoMassivoDaInviare(dichiarazioniIds, anno).then((x) => {
      if (!x.Success) {
        x.DetectedProblems.unshift('Errore durante cambio stato massivo Trasmetti');
        SnackbarManager.notifyError(x.DetectedProblems);
      } else {
        SnackbarManager.startDeterminateAsyncTask(x.CorrelationId, 'Modifica Stato', dichiarazioniIds.length);
      }
    });
  });
};

const azioneMassivaCompleta = (selezionati, anno) => {
  Confirm('Cambio stato', "Cambiare lo stato a 'Completa' per le dichiarazioni selezionate?", 'warning').then((y) => {
    const dichiarazioniIds = [];
    selezionati.forEach((element) => {
      if (element.IdDichiarazione != null) {
        dichiarazioniIds.push(element.IdDichiarazione);
      }
    });
    cambioStatoMassivoCompleta(dichiarazioniIds, anno).then((x) => {
      if (!x.Success) {
        x.DetectedProblems.unshift('Errore durante cambio stato massivo Completa');
        SnackbarManager.notifyError(x.DetectedProblems);
      } else {
        SnackbarManager.startDeterminateAsyncTask(x.CorrelationId, 'Modifica Stato', dichiarazioniIds.length);
      }
    });
  });
};

const azioneMassivaAnnulla = (selezionati, anno) => {
  Confirm('Cambio stato', 'Annullare le dichiarazioni selezionate?', 'warning').then((y) => {
    const dichiarazioniIds = [];
    selezionati.forEach((element) => {
      if (element.IdDichiarazione != null) {
        dichiarazioniIds.push(element.IdDichiarazione);
      }
    });
    cambioStatoMassivoAnnulla(dichiarazioniIds, anno).then((x) => {
      if (!x.Success) {
        x.DetectedProblems.unshift('Errore durante cambio stato massivo Annulla');
        SnackbarManager.notifyError(x.DetectedProblems);
      } else {
        SnackbarManager.startDeterminateAsyncTask(x.CorrelationId, 'Modifica Stato', dichiarazioniIds.length);
      }
    });
  });
};

const azioneMassivaInLavorazione = (selezionati, anno) => {
  Confirm('Cambio stato', "Cambiare lo stato a 'In lavorazione' per le dichiarazioni selezionate?", 'warning').then((y) => {
    const dichiarazioniIds = [];
    selezionati.forEach((element) => {
      if (element.IdDichiarazione != null) {
        dichiarazioniIds.push(element.IdDichiarazione);
      }
    });
    cambioStatoMassivoInLavorazione(dichiarazioniIds, anno).then((x) => {
      if (!x.Success) {
        x.DetectedProblems.unshift('Errore durante cambio stato massivo In Lavorazione');
        SnackbarManager.notifyError(x.DetectedProblems);
      } else {
        SnackbarManager.startDeterminateAsyncTask(x.CorrelationId, 'Modifica Stato', dichiarazioniIds.length);
      }
    });
  });
};

const valutaAzioneMassivaAnnulla = (items, selezionaTutte) => {
  let abilitato = items.length > 0;
  items.forEach((x) => {
    if (!(x.Stato === StatoDichiarazione.DaControllare
      || x.Stato === StatoDichiarazione.DaInviare
      || x.Stato === StatoDichiarazione.TrasmessaManualmente)) {
      abilitato = false;
    }
  });
  const infoC = (selezionaTutte
    ? 'Non puoi eseguire il passaggio di stato se hai selezionato tutte le dichiarazioni'
    : 'Non puoi eseguire il passaggio di stato per dichiarazioni in stato diverso da Trasmessa CGN o Controllo Audit.');

  return {
    disabled: selezionaTutte || !abilitato,
    showInfo: selezionaTutte || !abilitato,
    infoContent: infoC,
  };
};

const valutaAzioneMassivaInLavorazione = (items, selezionaTutte) => {
  let abilitato = items.length > 0;
  items.forEach((x) => {
    if (!(x.Stato === StatoDichiarazione.Completa || x.Stato === StatoDichiarazione.Annullata
      || x.Stato === StatoDichiarazione.AnnullataAE
      || x.Stato === StatoDichiarazione.ScartataAudit
      || x.Stato === StatoDichiarazione.ScartataRicalcolo)) {
      abilitato = false;
    }
  });
  const infoC = (selezionaTutte
    ? 'Non puoi eseguire il passaggio di stato se hai selezionato tutte le dichiarazioni'
    : "Non puoi eseguire il passaggio di stato per dichiarazioni con stato diverso da 'Completa', 'Annullata', 'Annullata AE', 'Scartata Audit' o 'Scartata ricalcolo'");

  return {
    disabled: selezionaTutte || !abilitato,
    showInfo: selezionaTutte || !abilitato,
    infoContent: infoC,
  };
};

const valutaAzioneMassivaDaInviare = (items, selezionaTutte) => {
  let abilitato = items.length > 0;
  items.forEach((x) => {
    if (!(x.Stato === StatoDichiarazione.Completa
      || x.Stato === StatoDichiarazione.Annullata)) {
      abilitato = false;
    }
  });
  const infoC = (selezionaTutte
    ? 'Non puoi eseguire il passaggio di stato se hai selezionato tutte le dichiarazioni'
    : "Non puoi eseguire il passaggio di stato per dichiarazioni con stato diverso da 'Completa' o 'Annullata'.");
  return {
    disabled: selezionaTutte || !abilitato,
    showInfo: selezionaTutte || !abilitato,
    infoContent: infoC,
  };
};

const valutaAzioneMassivaCompleta = (items, selezionaTutte) => {
  let abilitato = items.length > 0;
  items.forEach((x) => {
    if (!(x.Stato === StatoDichiarazione.InLavorazione && !x.HaErrori)) {
      abilitato = false;
    }
  });
  const infoC = (selezionaTutte
    ? 'Non puoi eseguire il passaggio di stato se hai selezionato tutte le dichiarazioni'
    : "Non puoi eseguire il passaggio di stato per dichiarazioni in stato diverso da 'In Lavorazione'.");
  return {
    disabled: selezionaTutte || !abilitato,
    showInfo: selezionaTutte || !abilitato,
    infoContent: infoC,
  };
};

const valutaAzioneMassivaTabulati = (stampaDisabled) => {
  const abilitato = !stampaDisabled;
  return {
    disabled: !abilitato,
    showInfo: !abilitato,
    infoContent: 'Selezionare almeno una dichiarazione',
  };
};

const valutaAzioneMassivaStampa = (stampaDisabled) => {
  const abilitato = !stampaDisabled;
  return {
    disabled: !abilitato,
    showInfo: !abilitato,
    infoContent: 'Selezionare almeno una dichiarazione',
  };
};

const tabulatoDebitiCrediti = (selezionati, selezionaTutte, currentUserId, codiceUfficio, anno, filtri) => {
  const dichiarazioniIds = [];
  selezionati.forEach((element) => {
    if (element.IdDichiarazione != null) { // escludo anno precedente
      dichiarazioniIds.push({ id: element.IdDichiarazione, cf: element.CodiceFiscale, origine: element.DatiAddizionali.Origine });
    }
  });

  creaTabulatoDebitiCrediti(
    (!selezionaTutte ? dichiarazioniIds : null),
    currentUserId,
    codiceUfficio,
    anno,
    filtri,
  ).then((x) => {
    if (!x.Success) {
      x.DetectedProblems.unshift('Errore durante la creazione del file');
      SnackbarManager.notifyError(x.DetectedProblems);
    } else {
      const sampleArr = base64ToArrayBuffer(x.Response.FileGenerato);
      saveByteArray('Tabulato_debiti_crediti.xls', sampleArr);
    }
  });
};

const tabulatoOneriAnnoPrecedente = (selezionati, selezionaTutte, currentUserId, codiceUfficio, anno, filtri) => {
  const dichiarazioniIds = [];
  selezionati.forEach((element) => {
    dichiarazioniIds.push({ id: element.IdDichiarazione, cf: element.CodiceFiscale, origine: element.DatiAddizionali.Origine });
  });
  creaTabulatoOneriAnnoPrecedente(
    (!selezionaTutte ? dichiarazioniIds : null),
    currentUserId,
    codiceUfficio,
    anno,
    filtri,
  ).then((x) => {
    if (!x.Success) {
      x.DetectedProblems.unshift('Errore durante la creazione del file');
      SnackbarManager.notifyError(x.DetectedProblems);
    } else {
      const sampleArr = base64ToArrayBuffer(x.Response.FileGenerato);
      saveByteArray('Tabulato_oneri_anno_precedente.xls', sampleArr);
    }
  });
};

const tabulatoDettaglioProspettoLiquidazioneQuadroA = (selezionati, selezionaTutte, currentUserId, codiceUfficio, anno, filtri) => {
    const dichiarazioniIds = [];
    selezionati.forEach((element) => {
        if (element.IdDichiarazione != null) { // escludo anno precedente
            dichiarazioniIds.push({ id: element.IdDichiarazione, cf: element.CodiceFiscale, origine: element.DatiAddizionali.Origine });
        }
    });

    creaTabulatoDettaglioProspettoLiquidazioneQuadroA(
        (!selezionaTutte ? dichiarazioniIds : null),
        currentUserId,
        codiceUfficio,
        anno,
        filtri,
    ).then((x) => {
        if (!x.Success) {
            x.DetectedProblems.unshift('Errore durante la creazione del file');
            SnackbarManager.notifyError(x.DetectedProblems);
        } else {
            const sampleArr = base64ToArrayBuffer(x.Response.FileGenerato);
            saveByteArray('Tabulato calcoli quadro A.xls', sampleArr);
        }
    });
};

const tabulatoDettaglioProspettoLiquidazioneQuadroB = (selezionati, selezionaTutte, currentUserId, codiceUfficio, anno, filtri) => {
    const dichiarazioniIds = [];
    selezionati.forEach((element) => {
        if (element.IdDichiarazione != null) { // escludo anno precedente
            dichiarazioniIds.push({ id: element.IdDichiarazione, cf: element.CodiceFiscale, origine: element.DatiAddizionali.Origine });
        }
    });

    creaTabulatoDettaglioProspettoLiquidazioneQuadroB(
        (!selezionaTutte ? dichiarazioniIds : null),
        currentUserId,
        codiceUfficio,
        anno,
        filtri,
    ).then((x) => {
        if (!x.Success) {
            x.DetectedProblems.unshift('Errore durante la creazione del file');
            SnackbarManager.notifyError(x.DetectedProblems);
        } else {
            const sampleArr = base64ToArrayBuffer(x.Response.FileGenerato);
            saveByteArray('Tabulato calcoli quadro B.xls', sampleArr);
        }
    });
};


function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

function saveByteArray(reportName, byte) {
  const blob = new Blob([byte], { type: 'application/pdf' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = reportName;
  link.click();
}

export default {
  stampaDiProva: azioneMassivaStampaDiProva,
  stampaUfficiale: azioneMassivaStampaUfficiale,
  stampeVarie: azioneMassivaStampeVarie,
  statoDaInviare: azioneMassivaDaInviare,
  statoAnnullata: azioneMassivaAnnulla,
  statoInLavorazione: azioneMassivaInLavorazione,
  statoCompleta: azioneMassivaCompleta,
  valutaAzioneMassivaAnnulla,
  valutaAzioneMassivaInLavorazione,
  valutaAzioneMassivaDaInviare,
  valutaAzioneMassivaCompleta,
  valutaAzioneMassivaTabulati,
  valutaAzioneMassivaStampa,
  tabulatoDebitiCrediti,
  tabulatoOneriAnnoPrecedente,
  tabulatoDettaglioProspettoLiquidazioneQuadroA,
  tabulatoDettaglioProspettoLiquidazioneQuadroB,
};
